module.exports = __webpack_public_path__ + "img/day-insurance-gary.3dbe931.png";